import React from "react"
import styled from "styled-components"
import Heading from "@/common/components/_UI/Heading"
import Text from "@/common/components/Text"
import { theme, btnShadow } from "@/common/Mixin"

interface CounterProps {
  data: any[]
  themeNew: any
}

const ShowCaseCounter = ({ data, themeNew }: CounterProps) => {
  return (
    <Wrapper className="counterShowCase">
      {data.map(({ content, desc }, index) => (
        <CardWrapper className="CounterBox" key={index} themeNew={themeNew}>
          <Heading
            as="h1"
            content={`${content}`}
            big
            themeNew={themeNew}
            primary
            center
          />
          <Text as="h2" content={desc} />
        </CardWrapper>
      ))}
    </Wrapper>
  )
}

export default ShowCaseCounter

const Wrapper = styled.section`
  width: 100%;
  text-align: center;
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--cardGap);
  @media (${theme.md}) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 36px;
    h2 {
      font-size: var(--h3);
    }
  }
`

interface CardWrapperProps {
  themeNew: any
}

const CardWrapper = styled.div<CardWrapperProps>`
  width: 100%;
  border: 1px solid
    ${({ themeNew }) => (themeNew ? themeNew.primary : theme.color.primary)};
  padding: var(--cardPadding);
  border-radius: var(--BORA);
  ${btnShadow}
  &:hover {
    transform: translate(0, -10px);
  }
  h1,
  h2 {
    margin: 0;
  }
`
